<template>
    <section>
        <div class="container is-max-desktop">
            <div class="columns is-multiline">
                <div class="column is-full">
                    <!-- Buscador -->
                    <div>
                        <SearchBox v-model="searchValue" :suggestions="suggestions" :show-suggestions="showSuggestions"
                            :total-suggestions="totalSuggestions" @autocomplete="handleAutocomplete"
                            @search="handleSearch" @select-suggestion="handleSuggestion" @reset="clearSearch" />
                    </div>
                    <!-- Título -->
                    <header class="mt-4">
                        <h3 class="titulo-bandera">{{ title }}</h3>

                    </header>
                </div>
                <!-- Resultados de la búsqueda -->
                <div v-if="searchQuery || selectedService" class="column is-full">
                    <p class="has-text-grey-light">
                        {{ totalResults }} {{ totalResults === 1 ? 'resultado' : 'resultados' }} de búsqueda para
                        <span class="has-text-weight-bold">{{ searchTerm }}</span>
                    </p>
                </div>

                <!-- Listado de servicios -->
                <div v-for="institucion in filteredInstituciones" :key="institucion.nombre"
                    class="column is-6-tablet is-4-widescreen">
                    <div class="card has-border-blue-light is-height-auto mb-4 p-5">
                        <h4 class="mb-3">{{ institucion.nombre }}</h4>
                        <a v-for="tramite in filteredTramites(institucion)"
                            :key="`${institucion.nombre}-${tramite.nombre}`" :href="tramite.url"
                            class="is-block remove-decoration-hover is-flex move-icon-hover has-font-serif mb-2">
                            <i class="las la-arrow-right mr-3 is-size-4"></i>
                            <div>{{ tramite.nombre }}</div>
                        </a>
                    </div>
                </div>
                <!-- Botón "Subir" alineado a la derecha y "Volver" alineado a la izquierda -->
                <div class="column is-full my-5 pb-0">
                    <div class="is-flex is-justify-content-space-between">
                        <div class="is-flex">
                            <a href="#" v-if="searchQuery || selectedService" class="button is-default"
                                @click.prevent="clearSearch">Volver</a>
                        </div>
                        <div class="is-flex">
                            <ScrollToTopButton />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
import ServiciosService from '../services/ServiciosService';
import SearchService from '../services/SearchService';
import SearchBox from './SearchBox.vue';

export default {
    name: 'MexServicios',
    components: {
        SearchBox
    },
    data() {
        return {
            instituciones: [],
            searchValue: '',
            searchQuery: '',
            showSuggestions: false,
            suggestions: [],
            totalSuggestions: 0,
            selectedService: null
        };
    },
    computed: {
        filteredInstituciones() {
            if (!this.searchQuery && !this.selectedService) {
                return this.instituciones;
            }

            return this.instituciones.filter(institucion =>
                this.filteredTramites(institucion).length > 0
            );
        },
        title() {
            if (this.searchQuery || this.selectedService) {
                return 'Resultados de la búsqueda';
            }
            return 'Listado de servicios disponibles';
        },
        totalResults() {
            if (!this.searchQuery && !this.selectedService) {
                return 0;
            }
            return this.filteredInstituciones.reduce((total, institucion) =>
                total + this.filteredTramites(institucion).length, 0
            );
        },
        searchTerm() {
            return this.selectedService ? this.selectedService.nombre : this.searchQuery;
        }
    },
    methods: {
        handleAutocomplete(value) {
            if (value.length < 3) {
                this.suggestions = [];
                this.totalSuggestions = 0;
                this.showSuggestions = false;
                return;
            }
            const { results, total } = SearchService.searchServices(this.instituciones, value);
            this.suggestions = results;
            this.totalSuggestions = total;
            this.showSuggestions = true;
        },
        handleSearch(value) {
            this.searchQuery = value;
            this.searchValue = value;
            this.selectedService = null;
            this.showSuggestions = false;
        },
        handleSuggestion(suggestion) {
            this.searchValue = suggestion.nombre;
            this.selectedService = suggestion;
            this.searchQuery = suggestion.nombre;
            this.showSuggestions = false;
        },
        clearSearch() {
            this.searchValue = '';
            this.searchQuery = '';
            this.selectedService = null;
            this.showSuggestions = false;
            this.$emit('input', '');
        },
        filteredTramites(institucion) {
            if (!this.searchQuery && !this.selectedService) {
                return institucion.tramites;
            }

            const query = this.searchQuery.toLowerCase();
            return institucion.tramites.filter(tramite =>
                tramite.nombre.toLowerCase().includes(query)
            );
        }
    },
    created() {
        this.instituciones = ServiciosService.getInstituciones();
    }
};
</script>
